import React, { Component, createRef } from "react";
import ReactDOM from "react-dom";
import { connect } from "react-redux";
import * as actions from "../../actions";
import countryList from "react-select-country-list";
import "react-phone-input-2/lib/style.css";
import "antd/dist/antd.css";
import PhoneInputDropdown from "./PhoneInputDropdown";
import { withRouter } from "react-router-dom";
import PropTypes from "prop-types";
import styled, { css } from 'styled-components';
import {
  Form,
  Input,
  Radio,
  Select,
  Row,
  Col,
  Checkbox,
  Typography,
} from "antd";
import AutorizedPersonsForm from "./AutorizedPersonsForm";
import TradeReferencesForm from "./TradeReferencesForm";
import { radioStyle } from "./styles";

const { Title } = Typography;

const { Option } = Select;

class SignUpForm2 extends React.Component {
    state = {
        showInput: false, // State to track whether to show the input box
      };


    handleInputChange = e => {
      const value = e.target.value;
      this.setState({
        showInput: value === 'yes', // Show input box only if 'yes' is selected
      });
    };
     
    
  render() {
    const { getFieldDecorator } = this.props.form;
    const { showInput } = this.state;
    const { initialFormData } = this.props; // Access initialFormData from props


    const labelStyle = {
      fontWeight: "800",
      fontSize: "16px",
      width: '100%',
      textAlign:'left',
      whiteSpace: 'normal'
    };

    const options = countryList().getData();
  
    return (
      <div>
        <Row>
          <Title
            level={2}
            style={{ paddingBottom: "1rem", borderBottom: "2px solid black" }}
          >
            Trade Financing
          </Title>
          <Col xs={24} sm={24} md={12}>
            <Form.Item
              label={<span style={labelStyle}>Credit Amount Requested</span>}
            >
              {getFieldDecorator("credit_amount_requested", {
                initialValue: initialFormData.credit_amount_requested,
                rules: [{ required: true, message: "Required" },
                  {
                    pattern: /^\d+(\.\d+)?$/, // Regular expression to accept integers or decimal numbers
                    message: 'Please enter a valid credit amount',
                  },],
              })(<Input size="large" placeholder="Credit Amount" />)}
            </Form.Item>
          </Col>
        </Row>
        <Row>
        <Col xs={24} sm={24} md={24}>
          <Form.Item
            label={
              <span style={labelStyle}
              >
                Have you or any of your affiliates ever had credit with us
                before or purchased from us before?
              </span>
            }
            colon={false}
            labelAlign="left"
          >
            {getFieldDecorator("affiliates_credit", {
              initialValue: initialFormData.affiliates_credit,
              rules: [
                {
                  required: true,
                  message: "required",
                },
              ],
            })(
              <Radio.Group name="affiliates_credit" onChange={this.handleInputChange}>
                <Radio style={radioStyle} value={"yes"}>
                  Yes
                </Radio>
                <Radio style={radioStyle} value={"no"}>
                  No
                </Radio>
              </Radio.Group>
            )}
          </Form.Item>
        </Col>
        </Row>
        {/* Conditional rendering of the input box */}
        {showInput && (
          <Row>
          <Col xs={24} sm={24} md={12}>
            <Form.Item
              label={<span style={labelStyle}>If yes, under what name?</span>}
              colon={false}
            >
              {getFieldDecorator("affiliated_company_name", {
                initialValue: initialFormData.under_name,
                rules: [{ required: true, message: "Required" }],
              })(<Input size="large" placeholder="" />)}
            </Form.Item>
          </Col>
          </Row>
        )}

        {/* <div>{formItems}</div> */}

        <Row>
        <AutorizedPersonsForm
         {...{ form: this.props.form }}
         authorized_persons={this.props.authorized_persons}
         onAuthorizedDetailChange={this.props.handleAuthorizedDetailChange}
         onAddAuthorize={this.props.handleAddAuthorize}
         onDeleteAuthorize={this.props.handleDeleteAuthorize}
       />
        </Row>

        <Title
          level={2}
          style={{ paddingBottom: "1rem", borderBottom: "2px solid black" }}
        >
          Banking Information
        </Title>
        <Row
          type="flex"
          md={{ justify: "space-between" }}
          xs={{ justify: "center" }}
          sm={{ justify: "center" }}
          gutter={[{ xs: 8, sm: 16, md: 24, lg: 32 }, 16]}
        >
          <Col xs={24} sm={24} md={12}>
            <Form.Item
              label={<span style={labelStyle}>Name of Your Bank</span>}
            >
              {getFieldDecorator("bank_name", {
                initialValue: initialFormData.bank_name,
                rules: [{ required: true, message: "Required" }],
              })(<Input size="large" placeholder="" />)}
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} md={12}>
            <Form.Item label={<span style={labelStyle}>Contact Name</span>}>
              {getFieldDecorator("bank_contact_name", {
                initialValue: initialFormData.bank_contact_name,
                rules: [{ required: true, message: "Required" }],
              })(<Input size="large" placeholder="" />)}
            </Form.Item>
          </Col>
        </Row>

        <Form.Item label={<span style={labelStyle}>Address</span>}>

          <Form.Item>
            {getFieldDecorator("street", {
              initialValue: initialFormData.street,
              rules: [{ required: false, message: "Required" }],
            })(<Input size="large" placeholder="Street Address" />)}
          </Form.Item>

          <Form.Item>
            {getFieldDecorator("address", {
              initialValue: initialFormData.address,
              rules: [{ required: false, message: "Required" }],
            })(<Input size="large" placeholder="Address Line 2" />)}
          </Form.Item>

          <Row
            type="flex"
            md={{ justify: "space-between" }}
            xs={{ justify: "center" }}
            sm={{ justify: "center" }}
            gutter={[{ xs: 8, sm: 16, md: 24, lg: 32 }, 16]}
          >
            <Col xs={24} sm={24} md={12}>
              <Form.Item>
                {getFieldDecorator("city", {
                  initialValue: initialFormData.city,
                  rules: [{ required: false, message: "Required" }],
                })(<Input size="large" placeholder="City" />)}
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={12}>
              <Form.Item>
                {getFieldDecorator("state", {
                  initialValue: initialFormData.state,
                  rules: [{ required: false }],
                })(<Input size="large" placeholder="State / Province" />)}
              </Form.Item>
            </Col>
          </Row>
          <Row
            type="flex"
            md={{ justify: "space-between" }}
            xs={{ justify: "center" }}
            sm={{ justify: "center" }}
            gutter={[{ xs: 8, sm: 16, md: 24, lg: 32 }, 16]}
          >
            <Col xs={24} sm={24} md={12}>
              <Form.Item>
                {getFieldDecorator("postal", {
                  initialValue: initialFormData.postal,
                  rules: [{ required: false }],
                })(<Input size="large" placeholder="ZIP / Postal Code" />)}
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={12}>
              <Form.Item>
                {getFieldDecorator("country", {
                  initialValue: initialFormData?.country || undefined,
                  rules: [
                    {
                      required: false,
                    },
                  ],
                })(
                  <Select
                    name="country"
                    placeholder="Select Country"
                    size="large"
                  >
                    {options.map((country) => (
                      <Option key={country} value={country.label}>
                        {country.label}
                      </Option>
                    ))}
                  </Select>
                )}
              </Form.Item>
            </Col>
          </Row>
        </Form.Item>

        <Row
          type="flex"
          md={{ justify: "space-between" }}
          xs={{ justify: "center" }}
          sm={{ justify: "center" }}
          gutter={[{ xs: 8, sm: 16, md: 24, lg: 32 }, 16]}
        >
          <Col xs={24} sm={24} md={12}>
            <Form.Item
              name="phone"
              label={<span style={labelStyle}>Company Phone</span>}
            >
              {getFieldDecorator("phone", {
                initialValue: initialFormData.phone,
                rules: [
                  { required: false, message: "Phone number is required!" },
                ],
              })(<PhoneInputDropdown />)}
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} md={12}>
            <Form.Item label={<span style={labelStyle}>E-mail</span>}>
              {getFieldDecorator("email", {
                initialValue: initialFormData.email,
                rules: [
                  {
                    type: "email",
                    message: "The input is not valid E-mail!",
                  },
                  {
                    required: false,
                    message: "E-mail is required",
                  },
                ],
              })(<Input size="large" />)}
            </Form.Item>
          </Col>
        </Row>

        <Title
          level={2}
          style={{ paddingBottom: "1rem", borderBottom: "2px solid black" }}
        >
          Trade References
        </Title>

        <TradeReferencesForm
          {...{ form: this.props.form }}
          references={this.props.references}
          onReferenceChange={this.props.handleReferenceChange}
          onAddReference={this.props.handleAddReference}
          onDeleteReference={this.props.handleDeleteReference}
        />
        <Row>
        <Form.Item>
            {getFieldDecorator('privacy_policy', {
                valuePropName: 'checked',
                initialValue: initialFormData.privacy_policy,
              rules: [
                {
                  required: true,
                  message: 'required',
                },
              ],
            })( <Checkbox>
              I Agree to <a href='https://www.primefreight.com/terms-and-conditions/'>Terms and Conditions</a> and <a href='https://www.primefreight.com/privacy-policy/'>Privacy Policy</a>
            </Checkbox>)}
          </Form.Item>
        </Row>
        
      </div>
    );
  }
}

const WrappedSignUpForm2 = Form.create({ name: "signupForm2" })(
  SignUpForm2
);

SignUpForm2.propTypes = {
  final_search_form: PropTypes.object,
};
const mapStateToProps = (state) => {
  return {
    queryParams: state.route.queryParams,
    final_search_form: state.route.final_search_form,
  };
};

export default withRouter(
  connect(mapStateToProps, actions)(WrappedSignUpForm2)
);
